export const button = {
  colorScheme: {
    light: {
      root: {
        primary: {
          background: '{ai.primary.background}',
          hoverBackground: '{ai.primary.hover.background}',
          activeBackground: '{ai.primary.active.background}',
          borderColor: '{ai.primary.border.color}',
          hoverBorderColor: '{ai.primary.hover.border.color}',
          activeBorderColor: '{ai.primary.active.border.color}',
        },
        secondary: {
          background: '{ai.secondary.background}',
          hoverBackground: '{ai.secondary.hover.background}',
          activeBackground: '{ai.secondary.active.background}',
          borderColor: '{ai.secondary.border.color}',
          hoverBorderColor: '{ai.secondary.hover.border.color}',
          activeBorderColor: '{ai.secondary.active.border.color}',
        },
      },
    },
  },
};
